import { render } from "./subjectFusionInfo.vue?vue&type=template&id=a9a72824&scoped=true"
import script from "./subjectFusionInfo.vue?vue&type=script&lang=js"
export * from "./subjectFusionInfo.vue?vue&type=script&lang=js"

import "./subjectFusionInfo.vue?vue&type=style&index=0&id=a9a72824&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9a72824"]])

export default __exports__